<template>
  <div class="bg-white shadow rounded-lg overflow-hidden">
    <div v-if="title" class="bg-primary-800 px-6 py-4">
      <h2 class="text-lg font-medium text-white">{{ title }}</h2>
    </div>
    <div class="p-6">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  }
})
</script>

<style scoped>
.bg-primary-800 {
  background-color: #1a202c;
}
</style> 